import styled from "styled-components"

import truckDark from "../../images/svg/topYogunluk/truck-dark.svg"
import truckLight from "../../images/svg/topYogunluk/truck-light.svg"

import yukDark from "../../images/svg/topYogunluk/list-dark.svg"
import yukLight from "../../images/svg/topYogunluk/list-light.svg"

import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {BsCalendar2Check} from "react-icons/bs"

const Container = styled.div`
    width: 100%;
    border-radius: 15px;
    color: ${({ theme }) => theme.mainTextColor};

    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 10px 20px;
    border-radius: 10px;


    .item-date-container{
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        .icon-container{
            display: flex;
            justify-content: center;
            align-items: center;

            .icon{
                font-size: 1.2rem;
            }
        }
    }


    .yogunluk-container{
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;

      .yogunluk-item{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 220px;
        gap: 10px;

        img{
          width: 25px;
          margin-right: 5px;
        }

        .text{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
        }

        .number{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }

      }

    }


`



const GarajDetayListItem = ({item}) => {
    
    const {theme} = useSelector(state => state.layout)

    const dispatch = useDispatch()

    const [yukCounter, setYukCounter] = useState(0)

    const [aracCounter, setAracCounter] = useState(0)

    const yukTimer = 1000 / item.loadDensity
    const aracTimer = 1000 /item.vehicleDensity


      useEffect(()=> {
        const interval1 = setInterval(() => {
            if(item.loadDensity > yukCounter){
                setYukCounter((yukCounter) => yukCounter + 1);
            }
          }, yukTimer);
      
          return () => {
            clearInterval(interval1);
          };
      },[yukCounter ])

      useEffect(()=> {
        const interval2 = setInterval(() => {
            if(item.vehicleDensity > aracCounter){
                setAracCounter((aracCounter) => aracCounter + 1);
            }
          }, aracTimer);

          return () => {
            clearInterval(interval2);
          };
      },[aracCounter])


  return (
    <Container>
        <div className="item-date-container">
            <div className="icon-container">
                <BsCalendar2Check className="icon"/>
            </div>
            <div className="date">{item.entryTime}</div>
            <div className="time">{item.time}</div>
        </div>
        <div className="yogunluk-container">
            <div className="yogunluk-item">
                <img src={theme === "dark" ? yukLight : yukDark} alt={item.garaj+"yuk"} />
                <div className="text">Yük Yoğunluğu</div>
                <div className="number" style={{color: yukCounter <= 33 ? "#0EAC00" : yukCounter <= 66 ? "#EBB00E" :"#FF0000" }}>%{yukCounter}</div>
            </div>
            <div className="yogunluk-item">
            <img src={theme === "dark" ? truckLight : truckDark } alt={item.garaj+"yuk"} />
            <div className="text">Araç Yoğunluğu</div>
            <div className="number" style={{color: aracCounter <= 33 ? "#0EAC00" : aracCounter <= 66 ? "#EBB00E" :"#FF0000" }}>%{aracCounter}</div>
            </div>
        </div>
    </Container>
  )
}

export default GarajDetayListItem